export default __webpack_public_path__ + "static/media/file-download-shared-class.0f4c061a.svg";